<template>
  <div>
    <el-dialog id="calendar-dialog" width="900px" :show-close="false" :visible.sync="dialogVisible" :top="top">
      <button class="close" @click="dialogVisible = false"><img src="https://storage.healthathome.in.th/2e553489-8087-4618-8623-49e7f36df327.svg"></button>
      <div class="left" style="width: 550px; background: #F9F9FA;">
        <div class="full-left-right">
          <div style="display: flex; align-items: center">
            <span class="titile">{{ reservationTitle }}</span>
            <button
                v-if="clipboardReservation"
                class="copy-button"
                @click="() => { copyText(clipboardReservation, 'reservation') }"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                <path d="M2.23939 12.1643H7.69468C8.74337 12.1643 9.60325 11.3775 9.73772 10.365H10.0937C11.2353 10.365 12.1643 9.43604 12.1643 8.29451V2.23939C12.1643 1.09786 11.2353 0.168945 10.0938 0.168945H4.63846C3.49692 0.168945 2.56801 1.09786 2.56801 2.23939V2.56801H2.23939C1.09786 2.56801 0.168945 3.49692 0.168945 4.63846V10.0937C0.168945 11.2353 1.09786 12.1643 2.23939 12.1643ZM3.76754 2.23939C3.76754 1.75916 4.15822 1.36848 4.63846 1.36848H10.0937C10.574 1.36848 10.9647 1.75916 10.9647 2.23939V8.29445C10.9647 8.77474 10.574 9.16542 10.0938 9.16542H9.76519V4.63846C9.76519 3.49692 8.83627 2.56801 7.69474 2.56801H3.76754V2.23939ZM1.36848 4.63846C1.36848 4.15822 1.75916 3.76754 2.23939 3.76754H7.69468C8.17497 3.76754 8.56566 4.15822 8.56566 4.63846V10.0937C8.56566 10.574 8.17497 10.9647 7.69474 10.9647H2.23939C1.75916 10.9647 1.36848 10.574 1.36848 10.0938V4.63846Z" fill="#434B61"/>
              </svg>
              <img
                  v-if="showTooltip.reservation"
                  src="https://storage.healthathome.in.th/062de062-41f7-4260-9c9d-f8550b4597be.svg"
                  alt="tooltip"
                  class="tooltip"
                />
            </button>
          </div>
          <el-button size="mini" v-if="!isCaregiverDialog" @click="goEditReservation" type="text" class="edit-btn-dialog">แก้ไข</el-button>
        </div>
        <div class="full-left-right align-left">
          <img src="https://storage.healthathome.in.th/3dc4abc2-b2cd-4655-90fb-b679c2002a92.svg">
          <div>
            <p class="detail">{{ packageInfo }}</p>
            <p class="detail gray narrow" v-for="item in reservationDates" :key="item.start">{{ item }}</p>
          </div>
        </div>
        <div class="full-left-right align-left">
          <img src="https://storage.healthathome.in.th/b28bbf8b-b206-46a3-ab96-bcae82204f08.svg">
          <p class="detail">{{ reservationShift }}</p>
        </div>
        <div class="full-left-right align-left">
          <img src="https://storage.healthathome.in.th/141e6afd-b115-40ff-8913-7b44900f2ea2.svg">
          <p class="detail">{{ reservationWorkType }}</p>
        </div>
        <div class="full-left-right align-left">
          <img src="https://storage.healthathome.in.th/9003c7e7-0ece-4c17-a6cd-b529f67e9893.svg">
          <div style="width: 100%;">
            <div class="full-left-right">
              <p class="detail">{{ reservationArea }}</p>
            </div>
            <div class="full-left-right">
              <p class="detail gray narrow" style="line-height: 150%;">
                {{ reservationAreaHome }}
                <br v-if="reservationAreaHome && reservationAddressLocationUrl">
                <a
                    v-if="reservationAddressLocationUrl"
                    class="detail gray narrow"
                    style="text-decoration: underline; line-height: 150%;"
                    :href="reservationAddressLocationUrl"
                    target="_blank"
                >ดูแผนที่</a>
                <br v-if="reservationAreaHome && reservationAreaHospital"/>
                {{ reservationAreaHospital }}
                <br v-if="reservationAreaHospital && reservationHospitalLocationUrl">
                <a
                    v-if="reservationHospitalLocationUrl"
                    class="detail gray narrow"
                    style="text-decoration: underline; line-height: 150%;"
                    :href="reservationHospitalLocationUrl"
                    target="_blank"
                >ดูแผนที่</a>
              </p>
            </div>
          </div>
        </div>
        <div class="full-left-right align-left">
          <img src="https://storage.healthathome.in.th/ab2538de-5e3e-4338-8cf1-d55bd3b1daa4.svg">
          <p class="detail">{{ reservationCaregiver }}</p>
        </div>
        <div class="full-left-right align-left">
          <img src="https://storage.healthathome.in.th/31aabb27-c50d-46e2-94d2-b9f1d0d0b406.svg">
          <div style="width: 100%;">
            <div class="full-left-right">
              <p class="detail">{{ reservationPrice.packageLabel }}</p>
            </div>
            <div class="full-left-right">
              <p class="detail narrow">{{ reservationPrice.baseLabel }}</p>
              <p class="detail narrow">{{ reservationPrice.base }}</p>
            </div>
            <div class="full-left-right">
              <p class="detail narrow">{{ reservationPrice.mealLabel }}</p>
              <p class="detail narrow">{{ reservationPrice.meal }}</p>
            </div>
            <div class="full-left-right">
              <p class="detail gray narrow">{{ reservationPrice.discountLabel }}</p>
              <p class="detail gray narrow">{{ reservationPrice.discount }}</p>
            </div>
            <div class="full-left-right">
              <p class="detail gray narrow">ต่างจังหวัด</p>
              <p class="detail gray narrow">{{ reservationPrice.zone }}</p>
            </div>
            <div class="full-left-right">
              <p class="detail gray narrow">{{ reservationPrice.vatLabel }}</p>
              <p class="detail gray narrow">{{ reservationPrice.vat }}</p>
            </div>
            <div class="full-left-right" v-show="reservationCustomerType === 'company'">
              <p class="detail gray narrow">ภาษีหัก ณ ที่จ่าย</p>
              <p class="detail gray narrow">{{ reservationPrice.tax }}</p>
            </div>
            <div class="hr"></div>
            <div class="full-left-right">
              <p class="detail">ราคารวม</p>
              <p class="detail">{{ reservationPrice.net }}</p>
            </div>
          </div>
        </div>

        <div v-if="showSubscriptionDetail" class="hr gray" style="margin: 16px 0"></div>
        <div v-if="showSubscriptionDetail" class="full-left-right align-left">
          <img src="https://storage.healthathome.in.th/3dc4abc2-b2cd-4655-90fb-b679c2002a92.svg">
          <div style="width: 100%;">
            <div class="full-left-right">
              <div class="full-left-right align-left">
                <span class="detail">รอบนี้ : {{ paymentStatusNow }}</span>
              </div>
              <el-button v-if="status !== 'reserved' && !isCaregiverDialog" size="mini" :disabled="!canRefund || fake" @click="goCancelNow" type="text" class="edit-btn-dialog">ยกเลิก</el-button>
            </div>

            <div v-if="paymentDate" style="margin-top: 8px;" class="full-left-right">
              <div class="full-left-right align-left">
                <p class="detail gray narrow">วันตัดบัตร</p>
              </div>
              <p class="detail gray narrow">{{ paymentDate }}</p>
            </div>
            <div class="full-left-right">
              <div class="full-left-right align-left">
                <p class="detail gray narrow" style="margin-right: 8px;">การชำระ</p>
                <img
                  v-if="!isCaregiverDialog"
                  @click="!isPaid && handleUpdatePaymentStatus()"
                  src="https://storage.healthathome.in.th/d2450e91-adef-4115-b305-6b59c2f2aca6.svg"
                  :style="`margin: 0px; cursor: ${isPaid ? 'not-allowed' : 'pointer' }; opacity: ${isPaid ? 0.5 : 1 };`"
                />
              </div>
              <p class="detail gray narrow">{{ isPaid ? 'ชําระแล้ว' : 'ยังไม่ชําระ' }}</p>
            </div>
            <div v-if="paymentCard" class="full-left-right">
              <div class="full-left-right align-left">
                <p class="detail gray narrow" style="margin-right: 8px;">บัตรที่ตัดเงิน</p>
                <img
                  v-if="!isCaregiverDialog"
                  @click="!isPaid && (showConfirmUpdateCardDialog = true)"
                  src="https://storage.healthathome.in.th/d2450e91-adef-4115-b305-6b59c2f2aca6.svg"
                  :style="`margin: 0px; cursor: ${isPaid ? 'not-allowed' : 'pointer' }; opacity: ${isPaid ? 0.5 : 1 };`"
                />
              </div>
              <p class="detail gray narrow">{{ paymentCard }}</p>
            </div>
          </div>
        </div>

        <div v-if="showSubscriptionDetail&& isPaid && isRecurring" class="hr gray" style="margin: 16px 0"></div>

        <div v-if="showSubscriptionDetail && isPaid && isRecurring" class="full-left-right align-left">
          <img src="https://storage.healthathome.in.th/3dc4abc2-b2cd-4655-90fb-b679c2002a92.svg">
          <div style="width: 100%;">
            <div class="full-left-right">
              <div class="full-left-right align-left">
                <span class="detail">รอบหน้า : {{ paymentStatusNext }}</span>
              </div>
              <el-button size="mini" v-if="!isCaregiverDialog" :disabled="!recurringActive" @click="cancelNext" type="text" class="edit-btn-dialog">ยกเลิก</el-button>
            </div>

            <div v-if="nextStartDate" style="margin-top: 8px;" class="full-left-right">
              <div class="full-left-right align-left">
                <p class="detail gray narrow" style="margin-right: 8px;">วันเริ่มรอบหน้า</p>
                <img
                  v-if="!isCaregiverDialog"
                  @click="!nextCreated && subscriptionStartDateHandler()"
                  src="https://storage.healthathome.in.th/d2450e91-adef-4115-b305-6b59c2f2aca6.svg"
                  :style="`margin: 0px; cursor: ${nextCreated ? 'not-allowed' : 'pointer' }; opacity: ${nextCreated ? 0.5 : 1 };`"
                />
              </div>
              <p class="detail gray narrow">{{ nextStartDate }}</p>
            </div>
            <div v-if="nextStartDate" class="full-left-right">
              <div class="full-left-right align-left">
                <p class="detail gray narrow" style="margin-right: 8px;">วันตัดบัตร</p>
              </div>
              <p class="detail gray narrow">{{ nextPaymentDate }}</p>
            </div>
            <div v-if="nextStartDate" class="full-left-right">
              <div class="full-left-right align-left">
                <p class="detail gray narrow" style="margin-right: 8px;">การชำระ</p>
              </div>
              <p class="detail gray narrow">{{ nextPaid ? 'ชําระแล้ว' : 'ยังไม่ชําระ' }}</p>
            </div>
            <div v-if="nextStartDate" class="full-left-right">
              <div class="full-left-right align-left">
                <p class="detail gray narrow" style="margin-right: 8px;">บัตรที่ตัดเงิน</p>
                <img
                  v-if="!isCaregiverDialog"
                  @click="!nextPaid && (showConfirmUpdateCardDialog = true)"
                  src="https://storage.healthathome.in.th/d2450e91-adef-4115-b305-6b59c2f2aca6.svg"
                  :style="`margin: 0px; cursor: ${nextPaid ? 'not-allowed' : 'pointer' }; opacity: ${nextPaid ? 0.5 : 1 };`"
                />
              </div>
              <p class="detail gray narrow">{{ nextPaymentCard }}</p>
            </div>

          </div>
        </div>
      </div>
      <div class="right" style="width: 487px">
        <div>
          <div class="full-left-right">
            <div style="display: flex; align-items: center">
              <span class="titile">{{ status === 'reserved' ? 'งาน' : bookingTitle }}</span>
              <button
                  v-if="clipboardBooking"
                  class="copy-button"
                  @click="() => { copyText(clipboardBooking, 'booking') }"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                  <path d="M2.23939 12.1643H7.69468C8.74337 12.1643 9.60325 11.3775 9.73772 10.365H10.0937C11.2353 10.365 12.1643 9.43604 12.1643 8.29451V2.23939C12.1643 1.09786 11.2353 0.168945 10.0938 0.168945H4.63846C3.49692 0.168945 2.56801 1.09786 2.56801 2.23939V2.56801H2.23939C1.09786 2.56801 0.168945 3.49692 0.168945 4.63846V10.0937C0.168945 11.2353 1.09786 12.1643 2.23939 12.1643ZM3.76754 2.23939C3.76754 1.75916 4.15822 1.36848 4.63846 1.36848H10.0937C10.574 1.36848 10.9647 1.75916 10.9647 2.23939V8.29445C10.9647 8.77474 10.574 9.16542 10.0938 9.16542H9.76519V4.63846C9.76519 3.49692 8.83627 2.56801 7.69474 2.56801H3.76754V2.23939ZM1.36848 4.63846C1.36848 4.15822 1.75916 3.76754 2.23939 3.76754H7.69468C8.17497 3.76754 8.56566 4.15822 8.56566 4.63846V10.0937C8.56566 10.574 8.17497 10.9647 7.69474 10.9647H2.23939C1.75916 10.9647 1.36848 10.574 1.36848 10.0938V4.63846Z" fill="#434B61"/>
                </svg>
                <img
                    v-if="showTooltip.booking"
                    src="https://storage.healthathome.in.th/062de062-41f7-4260-9c9d-f8550b4597be.svg"
                    alt="tooltip"
                    class="tooltip"
                />
              </button>
            </div>
            <el-button v-if="!isCaregiverDialog" :disabled="status === 'reserved'" size="mini" @click="goEditBooking" type="text" class="edit-btn-dialog">แก้ไข</el-button>
          </div>
          <div class="full-left-right align-left">
            <img src="https://storage.healthathome.in.th/3dc4abc2-b2cd-4655-90fb-b679c2002a92.svg">
            <p v-if="status === 'reserved'" class="detail">-</p>
            <div v-else style="display: flex; flex-direction: column; align-items: flex-start;">
              <p class="detail">{{ bookingDatesLength }}</p>
              <p class="detail gray narrow" v-for="item in bookingDates" :key="item.start">{{ item }}</p>
            </div>
          </div>
          <div class="full-left-right align-left" style="margin-top: 16px;">
            <img src="https://storage.healthathome.in.th/31aabb27-c50d-46e2-94d2-b9f1d0d0b406.svg">
            <p v-if="status == 'reserved'" class="detail">-</p>
            <div v-else class="detail-container">
              <div class="detail-container full-left-right" style="flex-direction: row;">
                <p class="detail">{{ bookingPriceRate }}</p>
                <p class="detail">{{ bookingPrice }}</p>
              </div>
              <div class="detail-container full-left-right" style="flex-direction: row;">
                <p class="detail narrow">{{ bookingMealRate }}</p>
                <p class="detail narrow">{{ bookingMeal }}</p>
              </div>
              <div class="hr" ></div>
              <div class="detail-container full-left-right" style="font-weight: 700; flex-direction: row; margin-bottom: 24px;">
                    <p class="detail">ราคารวมที่จ่ายผู้ดูแล</p>
                    <p class="detail">{{ bookingTotalPrice }}</p>
              </div>
            </div>
          </div>
          <div v-if="status == 'reserved'" class="hr gray" style="margin: 16px 0"></div>
          <div v-if="status !== 'reserved'" class="full-left-right align-left">
            <img src="https://storage.healthathome.in.th/ab2538de-5e3e-4338-8cf1-d55bd3b1daa4.svg">
            <p v-if="status === 'reserved' || status === 'booking'" class="detail">-</p>
            <div v-else class="detail-container">
              <div class="caregiver-container">
                <span class="detail">{{ bookingCaregiver }}</span>
                <button v-if="!isCaregiverDialog" class="caregiver-left" @click="goLeave"><img src="https://storage.healthathome.in.th/cfed62b4-8f28-4d4a-8431-b560a26e4c7f.svg"></button>
              </div>
            </div>
          </div>
        </div>
        <button v-if="status === 'reserved'" class="footer" @click="goCreateBooking">
          <img src="https://storage.healthathome.in.th/aa0657f2-7b05-495a-8e92-1211bd722f26.svg">
          <span>สร้างงานหาผู้ดูแล</span>
        </button>
        <button v-if="status === 'booking'" class="footer" @click="goMatching">
          <img src="https://storage.healthathome.in.th/d7a9ad88-4407-42f8-8c4d-a7240bb3e76c.svg">
          <span>แมทช์ผู้ดูแลกับงาน</span>
        </button>
        <button v-if="isCaregiverDialog" class="footer" @click="goCalendar">
          <img src="https://storage.healthathome.in.th/df5992c4-9f2b-478c-ba5b-2d193754020e.svg">
          <span>ไปหน้าลูกค้าคนนี้</span>
        </button>
      </div>
    </el-dialog>

     <!-- Reason to Cancel Next Bill Dialog -->
    <el-dialog :visible.sync="showReasonToCancelNextBillDialog" :showClose="false"
      :closeOnClickModal="false" style="margin-top: 19vh;" width="30%">
      <div style="display: flex; align-items: flex-start; margin-top: 30px; flex-direction: column;">
        <div class="header-bold-18" style="margin-bottom: 8px;">สาเหตุการยกเลิกตั้งแต่รอบหน้าเป็นต้นไป</div>
        <el-radio-group class="group-vertical radio" style="display: flex; flex-direction: column; margin-top:24px;" v-model="isCancelByUpdateCard">
          <el-radio :label="false" style="margin-bottom: 12px;">ไม่ต้องการใช้ต่อ</el-radio>
          <el-radio :label="true">ต้องการใช้ต่อ</el-radio>
        </el-radio-group>
        <span class="detail gray medium" style="margin-top: 4px; margin-left: 24px;">แต่ต้องยกเลิก เช่น ลูกค้าต้องการเปลี่ยนวิธีการชำระเงิน ฯลฯ เป็นต้น </span>
      </div>
      <span class="dialog-footer" slot="footer">
        <el-button class="edit" type="primary" @click="cancelByUpdateCard">ยืนยัน</el-button>
      </span>
    </el-dialog>

    <!-- Success Update Card Dialog -->
    <el-dialog :visible.sync="showCancelByUpdateCardDialog" :showClose="false" :closeOnClickModal="false" style="margin-top: 19vh;" width="30%">
      <div style="display: flex; justify-content: row; align-items: center; margin-top: 30px;  margin-bottom: 35px;">
        <img width="38" height="38" src="https://storage.healthathome.in.th/faa9aca8-773e-44a3-b4cf-558d8e173c21.svg" />
        <div class="header-18" style="margin-left: 17px;">เย่! ทําการยกเลิกเรียบร้อย</div>
      </div>
    </el-dialog>

    <!-- Success Update Card Dialog -->
    <el-dialog :visible.sync="showSuccessUpdateCardDialog" :showClose="false" :closeOnClickModal="false" style="margin-top: 19vh;" width="30%">
      <div style="display: flex; justify-content: row; align-items: center; margin-top: 30px;  margin-bottom: 35px;">
        <img width="38" height="38" src="https://storage.healthathome.in.th/faa9aca8-773e-44a3-b4cf-558d8e173c21.svg" />
        <div class="header-18" style="margin-left: 17px;">เย่! ส่งลิงค์เรียบร้อยแล้ว</div>
      </div>
    </el-dialog>

    <!-- Reason Dialog for CancelNextBill -->
    <el-dialog :visible.sync="showReasonDialog" :showClose="false" :closeOnClickModal="false" style="margin-top: 10vh;" width="35%">
      <div class="header-bold-18" style="margin-bottom: 8px;">สาเหตุที่ต้องการจบสัญญา</div>
      <p style="margin-bottom: 0px;"><el-radio label="bad" style="font-size: 18px;" v-model="cancelNextReason.type" @change="changeReasonType()">Bad Ending</el-radio></p>
      <div v-if="cancelNextReason.type === 'bad'">
        <div style="margin-left: 25px; display: flex; align-items: baseline;">
          <span style="font-size: 18px; font-weight: 400; margin-right: 8px; white-space: nowrap;">ที่มา </span>
          <el-select v-model="cancelNextReason.from" placeholder="เลือกที่มา" @change="changeReasonFrom()" style="margin: 0 24px 14px 0; max-width: 100px; min-width: 100px;">
            <el-option key="Customer" label="ลูกค้า" value="ลูกค้า"></el-option>
            <el-option key="Carepro" label="ผู้ดูแล" value="ผู้ดูแล"></el-option>
          </el-select>
          <span style="font-size: 18px; font-weight: 400; margin-right: 8px; white-space: nowrap;">สาเหตุ </span>
          <el-select v-if="cancelNextReason.from !== 'ผู้ดูแล'" v-model="cancelNextReason.reason" placeholder="เลือกสาเหตุ" style="margin: 0 0 14px 0; width: 100%;">
            <el-option key="GetCareproFromOther" label="ได้คนจากที่อื่น" value="ได้คนจากที่อื่น"></el-option>
            <el-option key="DirectHire" label="จ้างตรง" value="จ้างตรง"></el-option>
            <el-option key="NoSkill" label="ไม่มีผู้ดูแลคุณสมบัติที่ต้องการ" value="ไม่มีผู้ดูแลคุณสมบัติที่ต้องการ"></el-option>
            <el-option key="WaitCaregiverHAH" label="รอผู้ดูแลจาก HAH คนเดิม" value="รอผู้ดูแลจาก HAH คนเดิม"></el-option>
            <el-option key="Expensive" label="ราคาแพง / ไม่มีส่วนลด" value="ราคาแพง / ไม่มีส่วนลด"></el-option>
            <el-option key="WantCancelCreditCard" label="ต้องการยกเลิกตัดบัตรเครดิต" value="ต้องการยกเลิกตัดบัตรเครดิต"></el-option>
            <el-option key="DontUnderstand" label="ไม่เข้าใจเงื่อนไขการให้บริการ" value="ไม่เข้าใจเงื่อนไขการให้บริการ"></el-option>
            <el-option key="Other" label="อื่นๆ (โปรดระบุ)" value="อื่นๆ"></el-option>
          </el-select>
          <el-select v-if="cancelNextReason.from === 'ผู้ดูแล'" v-model="cancelNextReason.reason" placeholder="เลือกสาเหตุ" style="margin: 0 0 32px 0;">
            <el-option key="NoCG" label="ไม่มีผู้ดูแลแทนงาน" value="ไม่มีผู้ดูแลแทนงาน"></el-option>
            <el-option key="NoContractCG" label="ไม่มีผู้ดูแลต่อสัญญา" value="ไม่มีผู้ดูแลต่อสัญญา"></el-option>
            <el-option key="Covid" label="ผู้ดูแลตรวจพบโควิด" value="ผู้ดูแลตรวจพบโควิด"></el-option>
            <el-option key="NoSkill" label="ปัญหาทักษะ ความชำนาญ" value="ปัญหาทักษะ ความชำนาญ"></el-option>
            <el-option key="NoSoftSkill" label="ปัญหา Soft skill" value="ปัญหา Soft skill"></el-option>
            <el-option key="NotSatisfied" label="ลูกค้าไม่พอใจการทำงาน" value="ลูกค้าไม่พอใจการทำงาน"></el-option>
            <el-option key="Other" label="อื่นๆ (โปรดระบุ)" value="อื่นๆ"></el-option>
          </el-select>
        </div>
      </div>

      <p style="margin-bottom: 0px;"><el-radio label="good" style="font-size: 18px;" v-model="cancelNextReason.type" @change="changeReasonType()">Good Ending</el-radio></p>
        <div v-if="cancelNextReason.type === 'good'">
           <div style="margin-left: 25px; display: flex; align-items: baseline;">
           <span style="font-size: 18px; font-weight: 400; margin-right: 8px; white-space: nowrap;">ที่มา </span>
            <el-select v-model="cancelNextReason.from" placeholder="เลือกที่มา" @change="changeReasonFrom()" style="margin: 0 24px 14px 0;  max-width: 100px; min-width: 100px;">
              <el-option key="Customer" label="ลูกค้า" value="ลูกค้า"></el-option>
              <el-option key="Other" label="อื่นๆ" value="อื่นๆ"></el-option>
            </el-select>
            <span style="font-size: 18px; font-weight: 400; margin-right: 8px; white-space: nowrap;">สาเหตุ </span>
            <el-select v-if="cancelNextReason.from !== 'อื่นๆ'" v-model="cancelNextReason.reason" placeholder="เลือกสาเหตุ" style="margin: 0 0 14px 0;  width: 100%;">
              <el-option key="Improves" label="คนไข้อาการดีขึ้น" value="คนไข้อาการดีขึ้น"></el-option>
              <el-option key="Dead" label="คนไข้เสียชีวิต" value="คนไข้เสียชีวิต"></el-option>
              <el-option key="ICU" label="คนไข้เข้า ICU" value="คนไข้เข้า ICU"></el-option>
              <el-option key="Hospital" label="คนไข้เข้ารพ.งดเฝ้า" value="คนไข้เข้ารพ.งดเฝ้า"></el-option>
              <el-option key="Behavior" label="พฤติกรรมของคนไข้/ญาติ" value="พฤติกรรมของคนไข้/ญาติ"></el-option>
              <el-option key="Covid" label="คนไข้ตรวจพบโควิด" value="คนไข้ตรวจพบโควิด"></el-option>
              <el-option key="Other" label="อื่นๆ (โปรดระบุ)" value="อื่นๆ"></el-option>
            </el-select>
            <el-select v-if="cancelNextReason.from === 'อื่นๆ'" v-model="cancelNextReason.reason" placeholder="อื่นๆ (โปรดระบุ)" style="margin: 0 0 14px 0;  width: 100%;" disabled>
              <el-option key="Other" label="อื่นๆ (โปรดระบุ)" value="อื่นๆ"></el-option>
            </el-select>
          </div>
        </div>

      <p style="margin-bottom: 0px;"><el-radio label="unknown" style="font-size: 18px;" v-model="cancelNextReason.type" @change="changeReasonType()">Unknown</el-radio></p>

      <el-row style="margin-top: 100px;">
        <el-col :span="4">
          <span style="font-size: 18px;">รายละเอียด</span>
        </el-col>
        <el-col :span="18">
          <el-input style="margin-left: 8px;" type="textarea" rows="3" width="65%" v-model="cancelNextReason.detail" @keydown="inputHandler" />
        </el-col>
      </el-row>

      <span class="dialog-footer" slot="footer">
        <el-button type="primary" @click="saveReason()" :disabled="isDisabledSaveReason" class="edit">ต่อไป</el-button>
      </span>
    </el-dialog>

    <!-- Confirm Update Card Dialog -->
    <el-dialog id="paid" :visible.sync="showConfirmUpdateCardDialog" :closeOnClickModal="false" style="margin-top: 19vh;" :showClose="false" width="30%">
      <div style="display: flex; justify-content: row; align-items: center; margin-top: 30px;">
        <img width="38" height="38" src="https://storage.healthathome.in.th/87d115c7-a7c9-48f0-a2c7-23728a96f917.svg" style="align-self: flex-start;" />
        <div class="header-18" style="margin-left: 17px;">ต้องการส่งลิงค์ให้ลูกค้าแก้ไขบัตรเครดิต/เดบิตหรือไม่ ?</div>
      </div>
      <span class="dialog-footer" slot="footer">
        <el-button class="cancel-button" @click="updateCard(false)">ยกเลิก</el-button>
        <el-button type="primary" @click="updateCard(true)" class="edit">ต้องการ</el-button>
      </span>
    </el-dialog>

    <!-- Update Payment Status Dialog -->
    <el-dialog id="paid" :visible.sync="showUpdatePaymentStatusDialog" :closeOnClickModal="false" :showClose="false" style="margin-top: 19vh;" width="30%">
      <div style="display: flex; flex-direction: column; align-items: flex-start; margin-top: 30px;">
        <div class="header-22" style="margin-bottom: 14px;">แก้ไข status การชําระ</div>
        <el-radio v-model="paidStatus" :label="false" style="margin-bottom: 12px;">ยังไม่ชำระ</el-radio>
        <el-radio v-model="paidStatus" :label="true" style="margin-bottom: 12px;">ชำระแล้ว</el-radio>
      </div>
      <span class="dialog-footer" slot="footer">
        <el-button class="cancel-button" @click="showUpdatePaymentStatusDialog = false">ยกเลิก</el-button>
        <el-button type="primary" @click="confirmPaid(paidStatus)" class="edit">ยืนยัน</el-button>
      </span>
    </el-dialog>

    <!-- Success Update Payment Status To Paid  Dialog -->
    <el-dialog :visible.sync="showSuccessUpdatePaidStatusToPaidDialog" :showClose="false" :closeOnClickModal="false" style="margin-top: 19vh;" width="30%">
      <div style="display: flex; justify-content: row; align-items: center; margin-top: 30px;  margin-bottom: 35px;">
        <img width="38" height="38" src="https://storage.healthathome.in.th/faa9aca8-773e-44a3-b4cf-558d8e173c21.svg" />
        <div class="header-18" style="margin-left: 17px;">เย่! อัพเดตเรียบร้อย</div>
      </div>
    </el-dialog>

    <!-- Update Start Date Next Reservation Dialog -->
    <el-dialog :visible.sync="showUpdateStartDateNextReservationDialog" :showClose="false" :closeOnClickModal="false" width="878px">
      <div style="display: flex; flex-direction: column; align-items: flex-start; margin-top: 30px; height: 635px;">
        <div class="header-22" style="margin-bottom: 30px;">แก้ไขวันเริ่มรอบหน้า</div>
        <div class="header-18" style="margin-bottom: 8px;">วันสุดท้ายของการจองรอบนี้ :  {{ nextReservationForm.parentEndDate }}</div>
        <div class="header-18" style="margin-bottom: 38px;">ระบบตั้งค่าวันเริ่มอัตโนมัติของการจองรอบหน้า : {{ startDate }}</div>
        <div class="calendar-container">
          <div class="btn-calendar-container">
            <el-button icon="el-icon-arrow-left" @click="goPreviousMonth" style="margin-top: -8px;"></el-button>
            <el-button icon="el-icon-arrow-right" @click="goNextMonth" style="margin-left: 604px; min-width: 60px; max-width: 60px; margin-top: -8px;"></el-button>
          </div>
          <day-picker-calendar
            id="calendarNextReservation"
            v-model="nextReservationForm.dates"
            ref="calendar"
            :isAllowAddEvent="true"
            :maxDate="31"
            :daysOff="nextReservationForm.daysOff"
            style="margin-top: 10px;"
            :pck="nextReservationForm.package"
            typeCalendar="createReservation"
            :initDate="true"
          ></day-picker-calendar>
        </div>
      </div>
      <span class="dialog-footer" slot="footer">
        <el-button class="cancel-button" @click="showUpdateStartDateNextReservationDialog = false">ยกเลิก</el-button>
        <el-button
          type="primary"
          @click="showUpdateStartDateNextReservationConfirmationDialog = true"
          class="edit"
          :disabled="!this.nextReservationForm.dates[0]"
        >
          ยืนยัน
        </el-button>
      </span>
    </el-dialog>

    <!-- Update Start Date Next Reservation Confirmation Dialog -->
    <el-dialog id="paid" :visible.sync="showUpdateStartDateNextReservationConfirmationDialog" :closeOnClickModal="false" style="margin-top: 19vh;" :showClose="false" width="30%">
      <div style="display: flex; justify-content: row; align-items: center; margin-top: 30px;">
        <img width="38" height="38" src="https://storage.healthathome.in.th/87d115c7-a7c9-48f0-a2c7-23728a96f917.svg" style="align-self: flex-start;" />
        <div style="margin-left: 17px; display: flex; flex-direction: column;">
           <div class="header-18">ยืนยันการแก้ไขวันเริ่มรอบหน้า</div>
           <div class="header-18">จากวันที่ {{ startRawDate }} เป็นวันที่ {{ startDate }}</div>
        </div>
      </div>
      <span class="dialog-footer" slot="footer">
        <el-button class="cancel-button" @click="showUpdateStartDateNextReservationConfirmationDialog = false">ไม่</el-button>
        <el-button type="primary" @click="confirmUpdateStartDateNextReservationVaildate()" class="edit">ยืนยัน</el-button>
      </span>
    </el-dialog>

    <!-- Success Update Dialog -->
    <el-dialog :visible.sync="showUpdateStartDateNextReservationSuccessDialog" :showClose="false" :closeOnClickModal="false" style="margin-top: 19vh;" width="30%">
      <div style="display: flex; justify-content: row; align-items: center; margin-top: 30px;  margin-bottom: 35px;">
        <img width="38" height="38" src="https://storage.healthathome.in.th/faa9aca8-773e-44a3-b4cf-558d8e173c21.svg" />
        <div style="margin-left: 17px; display: flex; flex-direction: column;">
           <div class="header-18">เย่!  อัพเดตเรียบร้อย</div>
          <div class="header-18">วันเริ่มรอบหน้า : {{ startDate }}</div>
        </div>
      </div>
    </el-dialog>

    <!-- Update Start Date Next Reservation To Today Confirmation Dialog -->
    <el-dialog id="paid" :visible.sync="showUpdateStartDateNextReservationToTodayConfirmationDialog" :closeOnClickModal="false" style="margin-top: 19vh;" :showClose="false" width="30%">
      <div style="display: flex; justify-content: row; align-items: center; margin-top: 30px;">
        <img width="38" height="38" src="https://storage.healthathome.in.th/87d115c7-a7c9-48f0-a2c7-23728a96f917.svg" style="align-self: flex-start;" />
        <div class="header-18" style="margin-left: 17px;">ยืนยันให้ระบบจะทําการตัดบัตรลูกค้าตอนนี้</div>
      </div>
      <span class="dialog-footer" slot="footer">
        <el-button class="cancel-button" @click="showUpdateStartDateNextReservationToTodayConfirmationDialog = false">ไม่</el-button>
        <el-button type="primary" @click="confirmUpdateStartDateNextReservation()" class="edit">ยืนยัน</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style lang="scss">
  #calendar-dialog {
    .el-dialog__body {
      overflow-x: hidden;
      margin-top: 10px;
      display: flex;
      flex-direction: row;
      padding: 0 !important;
      position: relative;
    }

    .el-dialog__header {
      display: none;
    }

    .el-input__inner {
      background: rgba(67, 75, 97, 0.07);
      border: 0;
      height: 32px;
      width: 92px;
      padding-left: 8px;
      font-family: 'Sukhumvit';

      &:disabled {
        &~.el-input__suffix {
          opacity: 0.4;
        }
      }
    }

    .el-icon-arrow-up {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: -4px;

      &:before {
        color: #434B61;
        font-weight: 900;
      }

      &:after {
        color: #A2A7B3;
        font-weight: 900;
      }
    }

    .el-radio__label {
      font-size: 14px;
      font-weight: 400 !important;
      padding-left: 4px;
    }
  }

  #paid {
    .cancel-button {
      min-width: 80.92px;
      border: 1.5px solid #409EFF;
      transition: .2s;
      span {
        color: #409EFF;
        transition: .2s;
      }
      &:hover {
        background: #409EFF;
        transition: .2s;
        span {
          color: #FFFFFF;
          transition: .2s;
        }
      }
    }
  }

  .el-message-box.cancel {
    .el-message-box__message {
      p {
        font-weight: 500;
        font-size: 18px;
        line-height: 29px;
        color: #434B61;
      }
    }
  }

  .fc-widget-content {
    background-color: #FFFFFF !important;
  }
</style>

<style lang="scss" scoped>
  .calendar-container {
    margin-top: 10px;
    margin-bottom: 100px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 950px;
  }

  .btn-calendar-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    position: absolute;
  }

  .full-calendar-container {
    width: 750px;
    height: 400px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .el-dialog {
    border-radius: 8px;
  }

  .close {
    position: absolute;
    top: 21px;
    right: 21px;
    padding: 0;
    border: 0;
    background: none;
    outline: none;
  }

  .full-left-right {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    &.align-left {
      justify-content: flex-start;
    }

    img {
      margin-right: 15.5px;
      align-self: flex-start;
      margin-top: 8px;
    }
  }

  .edit-btn-dialog {
    font-size: 14px;
    color: #5489FF;

    &:disabled {
      color: #D5D6DB;
    }

    &:hover:not([disabled]) {
      color: #A9C4FF;
    }
  }

  .detail {
    font-family: 'Sukhumvit-SemiBold';
    font-weight: 600;
    font-size: 14px;
    line-height: 32px;
    color: #434B61;
    margin-bottom: 0px;

    &.gray {
      color: #A2A7B3;

      &.narrow {
        margin-top: -8px;
      }

      &.medium {
        font-family: 'Sukhumvit-Medium';
        font-weight: 500;
      }
    }

    &.narrow {
        margin-top: -8px;
      }
  }

  .left {
    border-radius: 8px 0 0 8px;
    padding: 56px 52px 54px 63px;

    .titile {
      font-family: 'Sukhumvit-Bold';
      font-weight: 900;
      font-size: 22px;
      line-height: 35px;
    }
  }

  .right {
    border-radius: 0 8px 8px 0;
    padding: 56px 40px 54px 47px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .detail-container {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 100%;
    }

    .titile {
      font-family: 'Sukhumvit-Bold';
      font-weight: 900;
      font-size: 22px;
      line-height: 35px;
    }

    .caregiver-container {
      padding: 5px 9px 5px 8px;
      background: rgba(213, 214, 219, 0.3);
      border-radius: 4px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;

      button {
        padding: 0;
        border: 0;
        background: none;
        outline: none;

        img {
          margin: 0;
          margin-top: 5px;
        }

        &:hover {
          &:not([disabled]) {
            transition: .1s;

            img {
              opacity: 0.3;
            }
          }
          &:disabled {
            cursor: not-allowed;
          }
        }

        &:disabled {
          img {
            opacity: 0.3;
          }
        }
      }
    }

    .footer {
      width: 100%;
      padding: 5.5px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #5489FF;
      border-radius: 4px;
      border: 0;
      outline: none;

      img {
        margin-right: 16px;
      }

      span {
        font-family: 'Sukhumvit-Bold';
        font-weight: 900;
        font-size: 18px;
        line-height: 29px;
        color: white;
      }

      &:hover {
        background: #76a1ff;
      }

      &:active {
        background-clip: #4c7be6;
      }

      &:focus {
        background: #76a1ff;
      }
    }
  }

  .hr {
    padding-right: 25px;
    border-bottom: 1px solid #434B61;
    margin: 5px 0;
    width: 100%;

    &.gray {
      border-bottom: 1px solid #D5D6DB;
    }
  }

  .header-bold-18 {
    font-weight: bold;
    font-size: 18px;
    line-height: 29px;
    color: #434B61;
  }

  .header-18 {
    font-weight: 500;
    font-size: 18px;
    line-height: 29px;
    color: #434B61;
  }

  .header-22 {
    font-family: 'Sukhumvit-Bold';
    font-weight: 700;
    font-size: 22px;
    line-height: 150%;
    color: #434B61;
  }

  .update-card-button {
    margin-left: 4px;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-width: 0px;
    padding: 5px 8px;
    border-radius: 4px;

    p {
      line-height: 125%;
    }

    img {
      margin: 0;
      margin-right: 5px;
      align-self: center;
    }

    &:hover  {
      opacity: 0.75;
    }
  }

  .copy-button {
    padding: 0;
    margin-left: 8px;
    width: 24px;
    height: 24px;
    border: 1px solid #434B61;
    background: transparent;
    border-radius: 50%;
    cursor: pointer;
    transition-duration: .3s;
    display: flex;
    align-items: center;
    justify-content: center;
    outline: none;
    position: relative;

    &:hover {
      background: #E9EAED;
    }

    &:active {
      background: #D5D6DB;
    }

    .tooltip {
      margin: 0px;
      position: absolute;
      top: -52px;
      filter: drop-shadow(0px 0px 20px rgba(0, 0, 0, 0.08));
    }
  }
</style>

<script>

import DayPickerCalendar from '@/components/shared/DayPickerCalendar'
import moment from 'moment'

export default {
  name: 'CalendarDialog',
  components: {
    DayPickerCalendar,
  },
  data () {
    return {
      patientId: '',
      id: '',
      bookingId: '',
      status: '',
      totalDates: '',
      reservationTitle: '',
      reservationDates: [],
      reservationShift: '',
      reservationWorkType: '',
      reservationArea: '',
      reservationAreaHome: '',
      reservationAddressLocationUrl: '',
      reservationAreaHospital: '',
      reservationHospitalLocationUrl: '',
      reservationCaregiver: '',
      reservationPrice: '',
      reservationCustomerType: '',
      bookingTitle: '',
      bookingDates: [],
      bookingCaregiver: '',
      bookingPrice: '',
      bookingPriceRate: '',
      bookingMeal: '',
      bookingMealRate: '',
      bookingTotalPrice: '',
      bookingDatesLength: '',
      dialogVisible: false,
      dialogType: 'patient',
      packageInfo: '',
      pck: '',
      isPaid: false,
      paidStatus: null,
      isRecurring: false,
      recurringActive: false,
      canRefund: false,
      paymentStatusNow: '',
      paymentStatusNext: '',
      paymentCard: '',
      paymentDate: '',
      nextCreated: '',
      nextPaid: '',
      nextPaymentCard: '',
      nextPaymentDate: '',
      nextStartDate: '',
      isCancelByUpdateCard: null,
      showReasonDialog: false,
      showReasonToCancelNextBillDialog: false,
      showCancelByUpdateCardDialog: false,
      cancelNextReason: {
        from: '',
        type: '',
        detail: '',
        reason: '',
      },
      showConfirmUpdateCardDialog: false,
      showSuccessUpdateCardDialog: false,
      showUpdatePaymentStatusDialog: false,
      showSuccessUpdatePaidStatusToPaidDialog: false,
      showUpdateStartDateNextReservationDialog: false,
      showUpdateStartDateNextReservationConfirmationDialog: false,
      showUpdateStartDateNextReservationToTodayConfirmationDialog: false,
      showUpdateStartDateNextReservationSuccessDialog: false,
      fake: false,
      nextReservationForm: {
        dates: [],
        daysOff: [],
        package: '',
        rawDates: [],
        parentEndDate: '',
      },
      showSubscriptionDetail: true,
      clipboardReservation: '',
      clipboardBooking: '',
      showTooltip: {
        reservation: false,
        booking: false
      },
    }
  },
  props: {
    typeDialog: {
      type: String,
      required: true,
    },
  },
  computed: {
    isDisabledSaveReason () {
      return this.cancelNextReason.type === ''
    },
    top () {
      return (10 - this.reservationDates.length) + 'vh'
    },
    isMonthlyWithAddon () {
      return this.pck === 'monthlyWithAddon'
    },
    isCaregiverDialog () {
      return this.typeDialog === 'caregiver'
    },
    startDate () {
      return this.nextReservationForm.dates[0] ? moment(this.nextReservationForm.dates[0]).format('DD/MM/YYYY') : '-'
    },
    startRawDate () {
      return this.nextReservationForm.rawDates[0] ? moment(this.nextReservationForm.rawDates[0]).format('DD/MM/YYYY') : '-'
    },
  },
  methods: {
    goPreviousMonth () {
      this.$refs.calendar.previousMonth()
      this.backgroundColorHandler()
    },
    goNextMonth () {
      this.$refs.calendar.nextMonth()
      this.backgroundColorHandler()
    },
    async forceUpdateCalendar () {
      await this.$refs.calendar.foceUpdateDataContinuous(this.nextReservationForm.dates)
      await this.backgroundColorHandler()
    },
    backgroundColorHandler () {
      document.querySelectorAll('[id^="calendarReservEdit"] .fc-day').forEach((day) => { day.style.backgroundColor = '#fff' })
      document.querySelectorAll('.fc-today').forEach((day) => { day.style.backgroundColor = '#e7f5ff' })
    },
    update (schedule, type) {
      this.updateUI(schedule)
      this.dialogVisible = true
      if (type === 'caregiver') this.dialogType = 'caregiver'
    },
    close () {
      this.dialogVisible = false
    },
    goEditReservation () {
      this.$router.push({ name: 'ReservationEdit', params: { id: this.patientId, reservationId: this.id } })
    },
    goEditBooking () {
      this.$router.push({ name: 'BookingEdit', params: { bookingId: this.bookingId, patientId: this.patientId, reservationId: this.id } })
    },
    goCancelNow () {
      this.$router.push({
        name: 'ReservationCancelNow',
        params: {
          reservationId: this.id,
        },
      })
    },
    async cancelNext () {
      this.dialogVisible = false
      try {
        await this.$confirm(`ลูกค้าต้องการยกเลิกระบบตัดบัตรอัตโนมัติ ตั้งแต่รอบหน้าเป็นต้นไป ?`, '', {
          confirmButtonText: 'ยืนยัน',
          cancelButtonText: 'ไม่',
          type: 'warning',
          customClass: 'cancel',
          cancelButtonClass: 'cancel-button',
          showClose: false,
          closeOnClickModal: false,
        })
        this.showReasonToCancelNextBillDialog = true
      } catch (error) {}
    },
    goCreateBooking () {
      this.$router.push({
        name: 'BookingCreate',
        params: {
          patientId: this.patientId,
          reservationId: this.id,
        },
      })
    },
    goMatching () {
      this.$router.push({
        name: 'MatchingBoard',
        params: {
          patientId: this.patientId,
          reservationId: this.id,
          bookingId: this.bookingId,
        },
      })
    },
    goLeave () {
      this.$router.push({
        name: 'CaregiverLeaveForm',
        params: {
          patientId: this.patientId,
          reservationId: this.id,
          bookingId: this.bookingId,
        },
      })
    },
    goCalendar () {
      this.$router.push({
        name: 'PatientDetail',
        params: {
          id: this.patientId,
        },
        query: {
          tab: 'workcalendarTab',
        },
      })
    },
    inputHandler (e) {
      if (e.keyCode === 13 && e.shiftKey) {
        e.preventDefault()
        this.content = `${this.content}\n`
      }
    },
    async saveReason () {
      this.showReasonDialog = false
      try {
        await this.$api.Reservation.cancelNextBill(this.id, this.cancelNextReason)
        this.$alert('เย่!  ทําการยกเลิกเรียบร้อย', '', {
          showConfirmButton: false,
          closeOnHashChange: true,
          callback: () => {
            this.cancelNextReason = ''
            this.$emit('getCalendar')
          },
          type: 'success',
        })
      } catch (error) {
        this.showErrorDialog(error)
        this.cancelNextReason = ''
      }
    },
    async cancelByUpdateCard () {
      if (this.isCancelByUpdateCard) {
        try {
          await this.$api.Reservation.cancelContinue(this.id)
          this.showReasonToCancelNextBillDialog = false
          this.$emit('forceUpdate')
          setTimeout(() => {
            this.showCancelByUpdateCardDialog = true
          }, 250)
          setTimeout(() => {
            this.showCancelByUpdateCardDialog = false
          }, 2500)
        } catch (error) {
          this.showErrorDialog(error)
          this.cancelNextReason = ''
        }
      } else {
        this.showReasonToCancelNextBillDialog = false
        this.showReasonDialog = true
      }
      this.this.isCancelByUpdateCard = null
    },
    changeReasonFrom () {
      this.cancelNextReason.detail = ''
      this.cancelNextReason.reason = ''
      if (this.cancelNextReason.type === 'good' && this.cancelNextReason.from === 'อื่นๆ') {
        this.cancelNextReason.reason = 'อื่นๆ'
      }
    },
    changeReasonType () {
      this.cancelNextReason.from = ''
      this.cancelNextReason.reason = ''
      this.cancelNextReason.detail = ''
    },
    handleUpdatePaymentStatus () {
      this.paidStatus = this.isPaid
      this.showUpdatePaymentStatusDialog = true
    },
    async confirmPaid (confirm) {
      if (confirm) {
        try {
          await this.$api.Reservation.markPaid(this.id)
          this.isPaid = confirm
          this.$emit('forceUpdate')
          this.showUpdatePaymentStatusDialog = false
          setTimeout(() => {
            this.showSuccessUpdatePaidStatusToPaidDialog = true
          }, 250)
          setTimeout(() => {
            this.showSuccessUpdatePaidStatusToPaidDialog = false
          }, 2500)
        } catch (error) {
          this.showErrorDialog(error)
          this.showUpdatePaymentStatusDialog = false
        }
      } else {
        this.showUpdatePaymentStatusDialog = false
      }
    },
    updateUI (info) {
      this.patientId = info.calendarId
      this.id = info.id
      this.status = info.raw.status
      this.isPaid = info.raw.paid
      this.isRecurring = info.raw.recurring
      this.recurringActive = info.raw.recurringActive
      this.canRefund = info.raw.canRefund
      this.paymentStatusNow = info.raw.recurringLabel
      this.paymentStatusNext = info.raw.nextRecurringLabel
      this.paymentCard = info.raw.paymentCard
      this.paymentDate = info.raw.paymentDate
      this.nextPaid = info.raw.nextPaid
      this.nextPaymentCard = info.raw.nextPaymentCard
      this.nextPaymentDate = info.raw.nextPaymentDate
      this.nextStartDate = info.raw.nextStartDate
      this.nextCreated = info.raw.nextCreated
      this.reservationTitle = info.raw.reservationCard.title
      this.reservationDates = info.raw.reservationCard.dates
      this.reservationShift = info.raw.reservationCard.shift
      this.reservationWorkType = info.raw.reservationCard.workType
      this.reservationArea = info.raw.reservationCard.area
      this.reservationAreaHome = info.raw.reservationCard.address
      this.reservationAddressLocationUrl = info.raw.reservationCard.addressLocationUrl
      this.reservationAreaHospital = info.raw.reservationCard.hospital
      this.reservationHospitalLocationUrl = info.raw.reservationCard.hospitalLocationUrl
      this.reservationCaregiver = info.raw.reservationCard.caregiver
      this.reservationCustomerType = info.raw.customerType
      this.reservationPrice = info.raw.reservationCard.price
      this.reservationPrice.discountType = 'fixed'
      this.reservationPrice.discountValue = 100
      this.totalDates = info.raw.reservationCard.totalDates
      this.pck = info.raw.pck
      this.fake = info.raw.fake
      if (this.status !== 'reserved') {
        this.bookingTitle = info.raw.bookingCard.title
        this.bookingDates = info.raw.bookingCard.dates
        this.bookingCaregiver = info.raw.bookingCard.caregiver
        this.bookingPrice = info.raw.bookingCard.price
        this.bookingPriceRate = info.raw.bookingCard.priceRate
        this.bookingMeal = info.raw.bookingCard.meal
        this.bookingMealRate = info.raw.bookingCard.mealRate
        this.bookingTotalPrice = info.raw.bookingCard.total
        this.bookingId = info.raw.bookingId
        this.bookingDatesLength = info.raw.bookingCard.datesLength
      }
      this.packageInfo = info.raw.packageInfo
      this.showSubscriptionDetail = info.raw.showSubscriptionDetail
      this.clipboardReservation = info.raw.clipboardReservation
      this.clipboardBooking = info.raw.clipboardBooking
    },
    async updateCard (confirm) {
      if (confirm) {
        await this.$api.Reservation.editcard(this.id)
        this.showConfirmUpdateCardDialog = false
        this.dialogVisible = false
        setTimeout(() => {
          this.showSuccessUpdateCardDialog = true
        }, 250)
        setTimeout(() => {
          this.showSuccessUpdateCardDialog = false
        }, 2500)
      } else {
        this.showConfirmUpdateCardDialog = false
      }
    },
    async subscriptionStartDateHandler () {
      try {
        let raw = await this.$api.Reservation.preparenextstartdate(this.id)
        this.nextReservationForm.dates = [...raw.dates]
        this.nextReservationForm.rawDates = [...raw.dates]
        this.nextReservationForm.parentEndDate = raw.endDate
        this.nextReservationForm.daysOff = [...raw.daysOff]
        this.nextReservationForm.package = raw.pricePackage
        this.showUpdateStartDateNextReservationDialog = true
        this.$nextTick(_ => {
          this.forceUpdateCalendar()
        })
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
    async confirmUpdateStartDateNextReservationVaildate () {
      try {
        let res = await this.$api.Reservation.validatenextstartdate(this.id, this.nextReservationForm.dates[0])
        if (!res.validate) {
          this.showUpdateStartDateNextReservationConfirmationDialog = false
          this.showUpdateStartDateNextReservationToTodayConfirmationDialog = true
        } else {
          this.confirmUpdateStartDateNextReservation()
        }
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
    async confirmUpdateStartDateNextReservation () {
      try {
        await this.$api.Reservation.nextstartdate(this.id, this.nextReservationForm.dates[0])
        this.$emit('forceUpdate')
        this.showUpdateStartDateNextReservationToTodayConfirmationDialog = false
        this.showUpdateStartDateNextReservationConfirmationDialog = false
        this.showUpdateStartDateNextReservationDialog = false
        setTimeout(() => {
          this.showUpdateStartDateNextReservationSuccessDialog = true
        }, 250)
        setTimeout(() => {
          this.showUpdateStartDateNextReservationSuccessDialog = false
        }, 2500)
      } catch (error) {
        this.showErrorDialog(error)
        this.showUpdatePaymentStatusDialog = false
      }
    },
    copyText (text, type) {
      navigator.clipboard.writeText(text)
      this.showTooltip[type] = true
      setTimeout(() => {
        this.showTooltip[type] = false
      }, 1500)
    },
  },
}
</script>
